module.exports = __webpack_public_path__ + "static/media/my-investments-white.03622b55.svg";